import { render, staticRenderFns } from "./afVerificationRecordDetail.vue?vue&type=template&id=6534817d&scoped=true"
import script from "./afVerificationRecordDetail.vue?vue&type=script&lang=js"
export * from "./afVerificationRecordDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6534817d",
  null
  
)

export default component.exports